/* LUMIERE — frontend interactions (v7) */
(function(){
  'use strict';
  var $ = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.from((r||document).querySelectorAll(s));};
  var money = function(c){
    try{ var f = window.Shopify && Shopify.currency && Shopify.currency.active; return new Intl.NumberFormat(undefined,{style:'currency',currency:f||'GBP'}).format(c/100); }
    catch(e){ return '£'+(c/100).toFixed(2); }
  };
  var toast = function(msg){
    var t = $('#lum-toast');
    if(!t){ t=document.createElement('div'); t.id='lum-toast'; t.className='lum-toast'; document.body.appendChild(t); }
    t.innerHTML='<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7l3 3 5-6"/></svg><span></span>';
    t.querySelector('span').textContent=msg;
    t.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t=setTimeout(function(){t.classList.remove('is-on');},2200);
  };
  var refreshCartCount = function(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)return; return r.json();})
      .then(function(cart){if(!cart)return; $$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count; el.hidden=cart.item_count===0;});})
      .catch(function(){});
  };

  $$('[data-lumiere-announcement]').forEach(function(wrap){
    var msgs = $$('.lum-anno__msg', wrap);
    if (msgs.length<=1) return;
    var interval = parseInt(wrap.dataset.interval,10)||4200;
    var i=0;
    setInterval(function(){msgs[i].classList.remove('is-active'); i=(i+1)%msgs.length; msgs[i].classList.add('is-active');}, interval);
  });

  var header = $('[data-lumiere-header]');
  if (header){ var onScroll=function(){header.classList.toggle('is-scrolled', window.scrollY>8);}; window.addEventListener('scroll', onScroll, {passive:true}); onScroll(); }

  (function(){
    var mega = $('[data-lumiere-mega]');
    var wraps = $$('[data-lumiere-mega-wrap]');
    if (!mega || !wraps.length) return;
    var closeTimer=null, hovering=0;
    var open = function(){ clearTimeout(closeTimer); mega.hidden=false; requestAnimationFrame(function(){mega.classList.add('is-open');}); };
    var close = function(){ mega.classList.remove('is-open'); setTimeout(function(){if(hovering===0) mega.hidden=true;},220); };
    var enter = function(){ hovering++; clearTimeout(closeTimer); open(); };
    var leave = function(){ hovering=Math.max(0,hovering-1); closeTimer=setTimeout(function(){if(hovering===0) close();},350); };
    wraps.forEach(function(w){ w.addEventListener('mouseenter', enter); w.addEventListener('mouseleave', leave); w.addEventListener('focusin', enter); w.addEventListener('focusout', leave); });
    mega.addEventListener('mouseenter', enter);
    mega.addEventListener('mouseleave', leave);
    document.addEventListener('keydown', function(e){if(e.key==='Escape') close();});
  })();

  (function(){
    var btn = $('[data-lumiere-mobile-toggle]');
    var closeBtn = $('[data-lumiere-mobile-close]');
    var nav = $('[data-lumiere-mobile-nav]');
    var scrim = $('[data-lumiere-scrim]');
    if (!btn || !nav || !scrim) return;
    var openNav = function(){ nav.hidden=false; scrim.hidden=false; requestAnimationFrame(function(){nav.classList.add('is-on'); scrim.classList.add('is-on');}); document.body.classList.add('lum-no-scroll'); btn.setAttribute('aria-expanded','true'); };
    var closeNav = function(){ nav.classList.remove('is-on'); scrim.classList.remove('is-on'); setTimeout(function(){nav.hidden=true; scrim.hidden=true;},260); document.body.classList.remove('lum-no-scroll'); btn.setAttribute('aria-expanded','false'); };
    btn.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    scrim.addEventListener('click', closeNav);
    document.addEventListener('keydown', function(e){if(e.key==='Escape' && !nav.hidden) closeNav();});
  })();

  // ─── Search overlay with predictive results ─────────────────────────
  (function(){
    var overlay = $('[data-search-overlay]');
    var input = $('[data-search-input]');
    var resultsEl = $('[data-search-results]');
    var suggestedEl = $('[data-search-suggested]');
    var form = $('[data-search-form]');
    if (!overlay || !input || !form) return;
    var openSearch = function(){
      overlay.hidden = false;
      requestAnimationFrame(function(){ overlay.classList.add('is-on'); });
      document.body.classList.add('lum-no-scroll');
      setTimeout(function(){ input.focus(); }, 200);
    };
    var closeSearch = function(){
      overlay.classList.remove('is-on');
      setTimeout(function(){ overlay.hidden = true; }, 280);
      document.body.classList.remove('lum-no-scroll');
    };
    $$('[data-search-toggle]').forEach(function(b){ b.addEventListener('click', openSearch); });
    var closeBtn = $('[data-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && !overlay.hidden) closeSearch(); });
    $$('[data-search-chip]').forEach(function(c){
      c.addEventListener('click', function(){ input.value = c.textContent.trim(); input.dispatchEvent(new Event('input')); });
    });

    var debounce = null;
    var doSearch = function(q){
      if (!q || q.length < 2){
        resultsEl.innerHTML = '';
        if (suggestedEl) suggestedEl.style.display = '';
        return;
      }
      if (suggestedEl) suggestedEl.style.display = 'none';
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(data){
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length){
            resultsEl.innerHTML = '<div class="lum-search-ov__empty">No matches. Try a broader term.</div>';
            return;
          }
          var html = products.map(function(p){
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var price = p.price ? money(parseInt(p.price.replace(/[^0-9]/g,''),10) || 0) : '';
            return '<a class="lum-search-ov__row" href="' + p.url + '">' +
              '<div class="lum-search-ov__thumb">' + (img ? '<img src="'+img+'" alt="" loading="lazy">' : '') + '</div>' +
              '<div class="lum-search-ov__row-meta"><div class="lum-search-ov__row-name">' + (p.title||'') + '</div>' +
              '<div class="lum-search-ov__row-sub">' + (p.product_type || '') + (price ? ' · ' + (p.price||'') : '') + '</div></div>' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 3l4 4-4 4"/></svg>' +
              '</a>';
          }).join('');
          html += '<a class="lum-search-ov__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results for “' + q + '” →</a>';
          resultsEl.innerHTML = html;
        })
        .catch(function(){ resultsEl.innerHTML = '<div class="lum-search-ov__empty">Search unavailable. Press Enter to try the full search page.</div>'; });
    };
    input.addEventListener('input', function(){
      clearTimeout(debounce);
      debounce = setTimeout(function(){ doSearch(input.value.trim()); }, 220);
    });
  })();

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-quick-add-btn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.disabled) return;
    var form = btn.closest('[data-quick-add]');
    if (!form) return;
    btn.classList.add('is-loading');
    var fd = new FormData(form);
    fetch(form.action || '/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json().then(function(d){return {r:r, d:d};});})
      .then(function(o){
        btn.classList.remove('is-loading');
        if (!o.r.ok){ toast(o.d.description || o.d.message || 'Could not add'); return; }
        btn.classList.add('is-ok');
        setTimeout(function(){btn.classList.remove('is-ok');}, 1800);
        refreshCartCount();
        toast('Added - ' + (o.d.product_title || 'item'));
      })
      .catch(function(){ btn.classList.remove('is-loading'); toast('Network error'); });
  });

  (function(){
    var section = $('[data-product-section]');
    if (!section) return;
    var form = $('[data-product-form]', section);
    var variantsEl = $('[data-variants]', section);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    var variantInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var currentPrice = $('[data-current-price]', section);
    var comparePrice = $('[data-compare-price]', section);
    var qtyInput = $('[data-qty-input]', section);
    var stickyPrice = $('[data-sticky-price]');
    var stickyBtn = $('[data-sticky-add-button]');
    var formatInputs = $$('[data-format-input]', section);
    // Read price as a guaranteed number (cents)
    var sectionUnitPrice = parseInt(section.dataset.unitPrice, 10) || 0;

    function getUnitPrice(){
      // Priority 1: variants JSON (handles variant switching)
      if (variants && variants.length){
        var id = variantInput ? parseInt(variantInput.value,10) : null;
        var v = variants.find(function(x){return x.id===id;});
        if (v && typeof v.price === 'number') return v.price;
        if (variants[0] && typeof variants[0].price === 'number') return variants[0].price;
      }
      // Priority 2: section's data-unit-price attribute (always rendered)
      if (sectionUnitPrice > 0) return sectionUnitPrice;
      // Priority 3: parse from hidden price text
      if (currentPrice){
        var raw = currentPrice.textContent.replace(/[^0-9.,-]/g,'').replace(',','.');
        return Math.round(parseFloat(raw) * 100) || 0;
      }
      return 0;
    }

    function getFormat(){
      var sel = formatInputs.find(function(f){return f.checked;});
      if (!sel) return {qty:1, discount:0, code:''};
      return {
        qty: parseInt(sel.dataset.qty,10) || 1,
        discount: parseFloat(sel.dataset.discount) || 0,
        code: sel.dataset.discountCode || ''
      };
    }

    function refreshFormatPrices(){
      if (!formatInputs.length) return;
      var unit = getUnitPrice();
      var singleEl = section.querySelector('[data-format-price-single]');
      var duoEl = section.querySelector('[data-format-price-duo]');
      if (singleEl) singleEl.textContent = money(unit);
      if (duoEl){
        var duoInput = formatInputs.find(function(f){return f.value==='duo';});
        if (duoInput){
          var qty = parseInt(duoInput.dataset.qty,10) || 2;
          var pct = parseFloat(duoInput.dataset.discount) || 0;
          var full = unit * qty;
          var discounted = full * (1 - pct/100);
          duoEl.innerHTML = pct > 0 ? money(discounted) + ' <s>' + money(full) + '</s>' : money(discounted);
        }
      }
    }

    function refreshAddButton(){
      var unit = getUnitPrice();
      var f = getFormat();
      var total = unit * f.qty * (1 - f.discount/100);
      if (qtyInput && formatInputs.length) qtyInput.value = f.qty;
      var available = true;
      if (variants && variants.length){
        var id = variantInput ? parseInt(variantInput.value,10) : null;
        var v = variants.find(function(x){return x.id===id;});
        if (v) available = v.available;
      }
      if (addBtn) addBtn.disabled = !available;
      if (addLabel){
        addLabel.innerHTML = available ? ('Add to cart · <span data-add-price>' + money(total) + '</span>') : 'Sold out';
      }
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (stickyBtn){
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? 'Add to cart' : 'Sold out';
      }
    }

    function updateVariant(){
      if (!variants || !variants.length || !form) return;
      var selected = $$('[data-option-input]', form).filter(function(r){return r.checked;}).map(function(r){return r.value;});
      var match = variants.find(function(v){return v.options.every(function(o,i){return o===selected[i];});});
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({},'',url);
      if (currentPrice) currentPrice.textContent = money(match.price);
      if (comparePrice){
        comparePrice.style.display = match.compare_at_price>match.price?'':'none';
        comparePrice.textContent = money(match.compare_at_price);
      }
      refreshFormatPrices();
      refreshAddButton();
    }
    $$('[data-option-input]', section).forEach(function(r){r.addEventListener('change', updateVariant);});
    formatInputs.forEach(function(f){f.addEventListener('change', refreshAddButton);});
    refreshFormatPrices();
    refreshAddButton();

    $$('[data-qty-step]', section).forEach(function(b){
      b.addEventListener('click', function(){
        var input = b.parentElement.querySelector('[data-qty-input]');
        if (!input) return;
        var delta = parseInt(b.dataset.qtyStep,10);
        input.value = Math.max(1, (parseInt(input.value,10)||1)+delta);
        var unit = getUnitPrice();
        var f = getFormat();
        var manualQty = parseInt(input.value,10) || 1;
        var total = unit * manualQty * (1 - f.discount/100);
        if (addLabel) addLabel.innerHTML = 'Add to cart · <span data-add-price>' + money(total) + '</span>';
        if (stickyPrice) stickyPrice.textContent = money(total);
      });
    });

    if (form){
      form.addEventListener('submit', function(e){
        if (!addBtn || addBtn.disabled) return;
        e.preventDefault();
        addBtn.classList.add('is-loading');
        var fd = new FormData(form);
        var f = getFormat();
        var formatLabel = '';
        if (formatInputs.length){
          var sel = formatInputs.find(function(x){return x.checked;});
          if (sel){ var lbl = sel.parentElement.querySelector('strong'); formatLabel = lbl ? lbl.textContent.trim() : sel.value; }
        }
        if (formatLabel && formatLabel.toLowerCase() !== 'single'){
          fd.append('properties[Format]', formatLabel);
        }
        var subInput = section.querySelector('[data-subscribe-input]');
        if (subInput && subInput.checked){
          fd.append('properties[Subscription]', 'Every 6 weeks');
        }
        fetch('/cart/add.js',{method:'POST', body:fd, headers:{'Accept':'application/json'}})
          .then(function(r){return r.json().then(function(d){return {r:r, d:d};});})
          .then(function(o){
            addBtn.classList.remove('is-loading');
            if (!o.r.ok){ toast(o.d.description || 'Could not add'); return; }
            addBtn.classList.add('is-ok');
            setTimeout(function(){addBtn.classList.remove('is-ok');}, 1800);
            refreshCartCount();
            if (f.code && f.qty > 1){
              window.location.href = '/discount/' + encodeURIComponent(f.code) + '?redirect=/cart';
              return;
            }
            toast('Added to cart');
          })
          .catch(function(){addBtn.classList.remove('is-loading'); toast('Network error');});
      });
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function(){ if (form) form.requestSubmit(); });

    var stickyBar = $('[data-sticky-add]');
    var heroEnd = $('.lum-pdp__cta', section);
    if (stickyBar && heroEnd){
      var obs = new IntersectionObserver(function(entries){entries.forEach(function(en){stickyBar.hidden = en.isIntersecting;});}, {rootMargin:'-120px 0px 0px 0px'});
      obs.observe(heroEnd);
    }

    var tabBtns = $$('[data-tab-btn]', section);
    var tabPanels = $$('[data-tab-panel]', section);
    if (tabBtns.length && tabPanels.length){
      var showTab = function(name){
        tabBtns.forEach(function(b){b.classList.toggle('is-active', b.dataset.tabBtn===name);});
        // On desktop hide siblings; on mobile they're all visible (CSS overrides [hidden])
        tabPanels.forEach(function(p){p.hidden = p.dataset.tabPanel!==name;});
      };
      tabBtns.forEach(function(b){b.addEventListener('click', function(){showTab(b.dataset.tabBtn);});});
      showTab(tabBtns[0].dataset.tabBtn);
    }

    var galleryMain = $('[data-gallery-main]');
    if (galleryMain){
      var track = $('[data-gallery-track]');
      var slides = $$('[data-gallery-slide]');
      var dots = $$('[data-gallery-dot]');
      var thumbs = $$('[data-gallery-thumb]');
      var idx = 0;
      var viewCounter = section.querySelector('[data-view-count]');
      var totalSlides = slides.length;
      var go = function(i){
        idx = Math.max(0, Math.min(slides.length-1, i));
        track.style.transform = 'translateX(-'+(idx*100)+'%)';
        dots.forEach(function(d,j){d.classList.toggle('is-on', j===idx);});
        thumbs.forEach(function(d,j){d.classList.toggle('is-on', j===idx);});
        if (viewCounter) viewCounter.textContent = 'View ' + (idx+1) + ' of ' + totalSlides;
      };
      go(0);
      var p = $('[data-gallery-prev]'); if (p) p.addEventListener('click', function(){go(idx-1);});
      var n = $('[data-gallery-next]'); if (n) n.addEventListener('click', function(){go(idx+1);});
      dots.forEach(function(d){d.addEventListener('click', function(){go(parseInt(d.dataset.index,10));});});
      thumbs.forEach(function(d){d.addEventListener('click', function(){go(parseInt(d.dataset.index,10));});});

      var startX=0, dx=0, dragging=false;
      galleryMain.addEventListener('touchstart', function(e){startX = e.touches[0].clientX; dx=0; dragging=true; track.style.transition='none';}, {passive:true});
      galleryMain.addEventListener('touchmove', function(e){ if (!dragging) return; dx = e.touches[0].clientX - startX; track.style.transform = 'translateX(calc(-'+(idx*100)+'% + '+dx+'px))';}, {passive:true});
      galleryMain.addEventListener('touchend', function(){ dragging=false; track.style.transition=''; var th = galleryMain.clientWidth * 0.18; if (dx > th) go(idx-1); else if (dx < -th) go(idx+1); else go(idx); });
    }

    var fbt = section.querySelector('[data-fbt]');
    var summary = section.querySelector('[data-fbt-summary]');
    if (fbt && summary){
      var bundleTotalEl = summary.querySelector('[data-bundle-total]');
      var bundleBtn = summary.querySelector('[data-fbt-add-button]');
      var discountPct = bundleBtn ? (parseFloat(bundleBtn.dataset.discountPct) || 0) : 0;
      var mainItem = section.querySelector('.lum-fbt__item.is-locked');
      var mainPrice = mainItem ? (parseFloat(mainItem.dataset.price) || 0) : 0;

      var recalc = function(){
        var subtotal = mainPrice;
        $$('[data-fbt-checkbox]', section).forEach(function(cb){
          var item = cb.closest('[data-fbt-item]');
          var pid = item.dataset.productId;
          var line = summary.querySelector('[data-fbt-line][data-product-id="'+pid+'"]');
          var price = parseFloat(cb.dataset.price) || 0;
          if (cb.checked){
            subtotal += price;
            item.classList.add('is-on');
            if (line) line.classList.remove('lum-fbt__line--off');
          } else {
            item.classList.remove('is-on');
            if (line) line.classList.add('lum-fbt__line--off');
          }
        });
        var total = subtotal * (1 - discountPct/100);
        if (bundleTotalEl) bundleTotalEl.textContent = money(total);
      };
      $$('[data-fbt-checkbox]', section).forEach(function(cb){ cb.addEventListener('change', recalc); });
      recalc();

      if (bundleBtn){
        bundleBtn.addEventListener('click', function(){
          bundleBtn.disabled = true;
          bundleBtn.classList.add('is-loading');
          var mainVariantInput = section.querySelector('[data-main-variant-id]');
          var items = [];
          if (mainVariantInput) items.push({id: parseInt(mainVariantInput.value,10), quantity: 1});
          $$('[data-fbt-checkbox]:checked', section).forEach(function(cb){
            items.push({id: parseInt(cb.dataset.variantId,10), quantity: 1});
          });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json', 'Accept':'application/json'},
            body: JSON.stringify({items: items})
          })
          .then(function(r){return r.json().then(function(d){return {r:r, d:d};});})
          .then(function(o){
            bundleBtn.disabled = false;
            bundleBtn.classList.remove('is-loading');
            if (!o.r.ok){ toast(o.d.description || 'Could not add bundle'); return; }
            refreshCartCount();
            var code = bundleBtn.dataset.discountCode;
            if (code){ window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; }
            else { window.location.href = '/cart'; }
          })
          .catch(function(){ bundleBtn.disabled = false; bundleBtn.classList.remove('is-loading'); toast('Network error'); });
        });
      }
    }
  })();

  // ─── Collection: sort + filter drawer + close ─────────────────────────
  (function(){
    var sortForm = $('[data-sort-form]');
    if (sortForm) sortForm.addEventListener('change', function(){
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortForm.elements.sort_by.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
    var toggleBtn = $('[data-filters-toggle]');
    var closeBtn = $('[data-filters-close]');
    var panel = $('[data-filters-panel]');
    var scrim = $('[data-filters-scrim]');
    if (!panel) return;
    var openF = function(){
      panel.classList.add('is-on');
      if (scrim){ scrim.hidden = false; requestAnimationFrame(function(){ scrim.classList.add('is-on'); }); }
      document.body.classList.add('lum-no-scroll');
    };
    var closeF = function(){
      panel.classList.remove('is-on');
      if (scrim){ scrim.classList.remove('is-on'); setTimeout(function(){ scrim.hidden = true; }, 200); }
      document.body.classList.remove('lum-no-scroll');
    };
    if (toggleBtn) toggleBtn.addEventListener('click', openF);
    if (closeBtn) closeBtn.addEventListener('click', closeF);
    if (scrim) scrim.addEventListener('click', closeF);
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && panel.classList.contains('is-on')) closeF(); });
  })();
})();
